import React, { useEffect, useState, useCallback } from 'react';
import { CiFilter } from 'react-icons/ci';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AiOutlineFileExcel } from "react-icons/ai";
import { FaFileContract } from "react-icons/fa";
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PaginationControls from '../../../setup/components/Building/components/Renders/PaginationControls';
// import AddMaintenanceContractModal from '../Maintenance Contract Entry/AddMaintenanceContractModal';
import ViewContractModal from '../Maintenance Contract Entry/ViewEditModal';
import AddContractModal from '../Maintenance Contract Entry/AddMaintenanceContractModal';
import { maintenanceContractFields } from '../Maintenance Contract Entry/maintenanceContractFields'; // Corrected import path
import { ColorRing } from 'react-loader-spinner';
import API_BASE_URL from '../../../../Constants';


const Maintenancecontractlist = () => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [isAddOpen, setIsAddOpen] = useState(false);
  // const [selectedContractId, setSelectedContractId] = useState(null);
  const [selectedContract, setSelectedContract] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isViewOpen, setIsViewOpen] = useState(false);
  // const [isEditOpen, setIsEditOpen] = useState(false); // For editing

  const [options, setOptions] = useState({});

  const [filterEnabled, setFilterEnabled] = useState(false); //to toogle filter functionality
  const [isHideVisible, setIsHideVisible] = useState(false); // to toggle hide/show filter button
  const [columnDropdowns, setColumnDropdowns] = useState({}); // to store dropdowns for each column
  const [filterSelection, setFilterSelection] = useState({}); // to track selected filter values
  const [filteredContracts, setFilteredContracts] = useState([]); // to store filtered contracts
  const [columnData, setColumnData] = useState([]); // to hold unique data for each column
  const [dateFilterSelection, setDateFilterSelection] = useState({
    coverageStartDate: { start: null, end: null },
    increaseDate: { start: null, end: null }
  });
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); //'asc' or 'desc'
  const [visibleColumns, setVisibleColumns] = useState({});


  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [
          buildingsRes,
          contractClassesRes,
          coverageTypesRes,
          coveragesRes,
          visitFrequenciesRes,
          billingLevelsRes,
          billingFrequencyRes,
          holdPeriodsRes
        ] = await Promise.all([
          fetch(API_BASE_URL + '/api/setup/buildings/all', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/contractclasses', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancecoveragetypes', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancecoverages', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancefrequencies', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancebillinglevels', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancebillingfrequencies', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenanceholdperiods', { credentials: 'include' }).then(res => res.json())
        ]);

        setOptions({
          buildingId: buildingsRes || [],
          contractClass: contractClassesRes || [],
          coverageType: coverageTypesRes || [],
          coverage: coveragesRes || [],
          visitFrequency: visitFrequenciesRes || [],
          billingLevel: billingLevelsRes || [],
          billingFrequency: billingFrequencyRes || [],
          holdPeriod: holdPeriodsRes || [],
        });
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
      }
    };


    fetchOptions();

  }, []);

  useEffect(() => {
    // Generate unique column data for filter dropdowns
    const generateColumnData = () => {
      const data = {};
      contracts.forEach((contract) => {
        Object.keys(contract).forEach((key) => {
          if (!data[key]) {
            data[key] = new Set();
          }
          console.log('contract[key]', contract[key]);
          if (contract[key] === null || contract[key] === undefined) {
            data[key].add('N/A'); // Add 'N/A' for null or undefined values
          } else {
            data[key].add(contract[key]);
          }
        });
      });
      const formattedData = {};
      Object.keys(data).forEach((key) => {
        formattedData[key] = Array.from(data[key]);
      });
      setColumnData(formattedData);
    };
    generateColumnData();
  }, [contracts]);


  useEffect(() => {
    const applyFilters = () => {
      let filtered = contracts;

      // Apply search filtering
      if (searchQuery.trim() !== '') {
        const lowerCaseQuery = searchQuery.toLowerCase();
        filtered = filtered.filter((contract) =>
          Object.values(contract).some(value =>
            value && value.toString().toLowerCase().includes(lowerCaseQuery)
          )
        );
      }

      // Apply dropdown filters
      if (Object.keys(filterSelection).length) {
        filtered = filtered.filter((contract) =>
          Object.keys(filterSelection).every((key) =>
            !filterSelection[key]?.length ||
            filterSelection[key].includes(contract[key]) ||
            (filterSelection[key].includes('N/A') && (contract[key] === null || contract[key] === undefined))
          )
        );
      }


      // Apply date filters
      filtered = filtered.filter((contract) => {
        return Object.keys(dateFilterSelection).every((key) => {
          const { start, end } = dateFilterSelection[key];
          if (!start && !end) return true; // No date filter applied


          const contractDateUTC = contract[key];

          if (!contractDateUTC) {
            return false;
          }

          const startUTC = start ? start.toISOString().split("T")[0] : null;
          const endUTC = end ? end.toISOString().split("T")[0] : null;



          if (startUTC && endUTC) {
            console.log({ contractDateUTC, startUTC, endUTC, state: contractDateUTC >= startUTC && contractDateUTC <= endUTC });
            return contractDateUTC >= startUTC && contractDateUTC <= endUTC;
          }
          if (startUTC) return contractDateUTC >= startUTC;
          if (endUTC) return contractDateUTC <= endUTC;

          return false;


        });
      });

      // Apply sorting
      if (sortBy) {
        filtered = [...filtered].sort((a, b) => {
          let valueA = a[sortBy];
          let valueB = b[sortBy];

          // Handle null/undefined
          if (valueA === null || valueA === undefined) valueA = '';
          if (valueB === null || valueB === undefined) valueB = '';

          // Determine data type for sorting
          const isDate = sortBy.includes('Date');
          const isNumber = ['invoiceAmount', 'increasePercent'].includes(sortBy);

          if (isDate) {
            valueA = new Date(valueA);
            valueB = new Date(valueB);
          } else if (isNumber) {
            valueA = parseFloat(valueA) || 0;
            valueB = parseFloat(valueB) || 0;
          } else {
            valueA = valueA.toString().toLowerCase();
            valueB = valueB.toString().toLowerCase();
          }

          if (valueA > valueB) return sortOrder === 'asc' ? 1 : -1;
          if (valueA < valueB) return sortOrder === 'asc' ? -1 : 1;
          return 0;
        });
      }

      setFilteredContracts([...filtered]);

    };

    applyFilters();
  }, [searchQuery, filterSelection, dateFilterSelection, contracts, sortBy, sortOrder]);


  // const toggleFilter = () => {
  //   setFilterEnabled(!filterEnabled);
  //   if(!filterEnabled){
  //     setFilterSelection({});
  //     setFilteredContracts(contracts);
  //   }
  // };

  // Initialize visibleColumns on component mount
  useEffect(() => {
    const initialVisibility = {};
    maintenanceContractFields.forEach((field) => {
      initialVisibility[field.name] = true;
    });
    setVisibleColumns(initialVisibility);
  }, []);

  const toggleColumnVisibility = (columnName) => {
    setVisibleColumns(prev => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const enableFilter = () => {
    setFilterEnabled(true);
    setIsHideVisible(true); // show the Hide button

    // Reset all columns to be visible when filter is enabled
    const allVisible = {};
    maintenanceContractFields.forEach((field) => {
      allVisible[field.name] = true;
    });
    setVisibleColumns(allVisible);
  };

  const disableFilter = () => {
    setFilterEnabled(false);
    setIsHideVisible(false); // hide the Hide button

    // Reset to show all columns when filter is disabled
    const allVisible = {};
    maintenanceContractFields.forEach((field) => {
      allVisible[field.name] = true;
    });
    setVisibleColumns(allVisible);
    
    setColumnDropdowns({}); // Reset dropdowns
    setFilterSelection({}); // Reset filters
    setDateFilterSelection({  // Reset date filters
      coverageStartDate: { start: null, end: null },
      increaseDate: { start: null, end: null }
    });
    setFilteredContracts(contracts); // Reset filtered contracts
  };

  const toggleDropdown = (column) => {
    setColumnDropdowns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };


  const handleCheckboxChange = (column, value, checked) => {
    setFilterSelection((prev) => {
      const updated = { ...prev };
      if (!updated[column]) {
        updated[column] = [];
      }
      // if(checked){
      //   updated[column].push(value);
      // }else{
      //   updated[column] = updated[column].filter((v) => v !== value);
      // }
      if (checked) {
        if (!updated[column].includes(value)) {
          updated[column].push(value);
        }
      } else {
        updated[column] = updated[column].filter((v) => v !== value);
      }

      // If no filters are selected, remove the key to avoid unnecessary filtering
      if (updated[column].length === 0) {
        delete updated[column];
      }
      return updated;
    });
  };



  // Fetch maintenance contracts with pagination and search
  const fetchContracts = useCallback(async (page = currentPage, size = rowsPerPage, query = searchQuery) => {
    try {
      setLoading(true);
      let url = `${API_BASE_URL}/api/maintenance/maintenance-contracts?page=${page - 1}&size=${size}`;

      if (query.trim() !== '') {
        url += `&q=${encodeURIComponent(query)}`;
      }

      const response = await fetch(url, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to fetch contracts");
      }

      const data = await response.json();
      console.log('Fetched contracts:', data);

      setContracts(Array.isArray(data.content) ? data.content : []);
      setCurrentPage(data.number + 1);
      setTotalPages(data.totalPages);

    } catch (error) {
      console.error('Error fetching contracts:', error);
      setContracts([]);

    } finally {
      setLoading(false);
    }
  }, [currentPage, rowsPerPage, searchQuery]);

  const exportToExcel = () => {
    // const dataToExport = (filteredContracts.length ? filteredContracts : contracts).map(contract => ({
    //   ContractNumber: contract.contractNumber || 'N/A',
    //   ContractClass: contract.contractClass || 'N/A',
    //   CoverageStartDate: contract.coverageStartDate || 'N/A',
    //   CoverageType: contract.coverageType || 'N/A',
    //   Coverage: contract.coverage || 'N/A',
    //   VisitFrequency: contract.visitFrequency || 'N/A',
    //   BillingLevel: contract.billingLevel || 'N/A',
    //   BillingFrequency: contract.billingFrequency || 'N/A',
    //   InvoiceAmount: contract.invoiceAmount || 'N/A',
    //   IncreaseDate: contract.increaseDate || 'N/A',
    //   IncreasePercent: contract.increasePercent || 'N/A',
    //   IncreaseFrequency: contract.increaseFrequency || 'N/A',
    //   HoldPeriod: contract.holdPeriod || 'N/A'
    // }));

    const currentColumns = filterEnabled
      ? maintenanceContractFields
      : maintenanceContractFields.filter(field => visibleColumns[field.name]);

    const dataToExport = (filteredContracts.length ? filteredContracts : contracts).map(contract => {
      const row = {};
      currentColumns.forEach((field) => {
        row[field.label] = contract[field.name] || 'N/A';
      });
      return row;
    });


    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance Contracts");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(data, 'Maintenance_Contracts.xlsx');
  };


  // useEffect(() => {
  //   fetchContracts();
  // }, [fetchContracts]);

  // useEffect(() => {
  //   fetchContracts(1, rowsPerPage, searchQuery);
  // }, [searchQuery, rowsPerPage, fetchContracts]); // Now fetches data when searchQuery updates

  useEffect(() => {
    fetchContracts(1, rowsPerPage);
  }, [rowsPerPage]); // Remove `searchQuery` from dependencies

  const handleDateChange = (column, type, date) => {
    setDateFilterSelection((prev) => ({
      ...prev,
      [column]: { ...prev[column], [type]: date ? new Date(date) : null },
    }));
  };

  const applyDateFilter = (column) => {
    setDateFilterSelection((prev) => ({ ...prev })); // Just trigger useEffect
    setDateFilterSelection((prev) => ({
      ...prev,
      [column]: { ...prev[column] }, // Ensure state updates and triggers useEffect
    }));
  };

  const clearDateFilter = (column) => {
    setDateFilterSelection((prev) => ({
      ...prev,
      [column]: { start: null, end: null }
    }));
  };



  const handlePageChange = (page) => setCurrentPage(page);

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    fetchContracts(1, newRowsPerPage, searchQuery);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    // setCurrentPage(1);
    //fetchContracts(1, rowsPerPage, e.target.value);
  };

  const handleOpenAddModal = () => setIsAddOpen(true);
  const handleCloseAddModal = () => setIsAddOpen(false);

  const handleOpenViewModal = (contract) => {

    setSelectedContract(contract);
    setCurrentIndex(contracts.findIndex((c) => c.contractId == contract.contractId));
    setIsViewOpen(true);
  };
  const handleCloseViewModal = () => setIsViewOpen(false);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">

        <ColorRing
          visible={loading}
          height="200"
          width="200"
          ariaLabel="color-ring-loading"
          colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
        />
      </div>
    );
  }

  return (
    <div className="mx-auto pl-4 pr-4 h-screen w-full">
      <div className="flex justify-between items-center mb-4">
        {/* <h2 className="text-2xl font-bold">Maintenance Contracts List</h2> */}

        <div className='flex justify-end gap-4'>
          {/* Filter Button */}
          <button
            //className="py-2 px-3 border rounded-lg text-sss-blue-sel font-bold hover:bg-sss-blue hover:text-white transition duration-300 ease-in-out"
            className="py-2 px-5 border rounded-lg text-white bg-[#1f658a] font-bold flex items-center gap-2 hover:bg-[#174d6a] transition duration-300 ease-in-out"
            onClick={enableFilter}
          >
            <CiFilter className="text-2xl" />
            Filter
          </button>

          {/* Hide Button */}
          {isHideVisible && (
            <button
              // className="py-2 px-3 border rounded-lg text-sss-blue-sel font-bold hover:bg-red-500 hover:text-white transition duration-300 ease-in-out"
              className="py-2 px-5 border rounded-lg text-white bg-red-500 font-bold flex items-center gap-2 hover:bg-red-700 transition duration-300 ease-in-out"
              onClick={disableFilter}
            >
              <FaEyeSlash className="text-xl" />
              Hide
            </button>
          )}
        </div>


        <div className="flex justify-end gap-4">
          {/* Search Bar */}
          <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
            <div className="px-3 py-2 text-gray-500">
              <SearchIcon />
            </div>
            <input
              type="text"
              className="px-3 py-2 w-full outline-none"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>

          {/* Add Button */}
          <div>
            <button
              className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
              onClick={handleOpenAddModal}
            >
              <FaFileContract className="text-xl mr-2" />
              New Contract
            </button>
          </div>

          {/* Export to Excel Button */}
          <div>
            <button
              className="border bg-green-500 rounded-lg px-5 py-2 flex text-white font-bold hover:bg-green-700 transition duration-300 ease-in-out"
              onClick={exportToExcel}
            >
              <AiOutlineFileExcel className="text-xl mr-2" />
              Excel
            </button>
          </div>
        </div>
      </div>

      {/* Contracts Table */}
      <table className="min-w-full bg-white rounded-lg shadow-lg overflow-visible border-2 border-gray-200 relative">
        <thead className="bg-gray-200">
          <tr>
            {maintenanceContractFields.map((field) => (
              <th 
                key={field.name} 
                style = {{ 
                  display: filterEnabled && !visibleColumns[field.name] ? 'none' : 'table-cell',
                  cursor: 'pointer'
                }}
                className={`px-4 py-2 text-left font-bold text-sss-blue-sel relative ${
                  !visibleColumns[field.name] && filterEnabled ? 'opacity-50' : ''
                }`}
                // onClick={(e) => {
                //   // Ignore clicks on the filter button
                //   if (e.target.tagName.toLowerCase() !== 'button') {
                //     if (sortBy === field.name) {
                //       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                //     } else {
                //       setSortBy(field.name);
                //       setSortOrder('asc');
                //     }
                //   }
                // }}
                onClick={(e) => {

                  if (e.target.tagName.toLowerCase() !== 'button' && visibleColumns[field.name]) {
                    if (sortBy === field.name) {
                      // Cycle through 3 states: asc -> desc -> none
                      setSortOrder(prev => {
                        if (prev === 'asc') return 'desc';
                        if (prev === 'desc') return null;
                        return 'asc';
                      });
                      // Clear sortBy when returning to normal order
                      if (sortOrder === 'desc') setSortBy(null);
                    } else {
                      // New column, start with ascending
                      setSortBy(field.name);
                      setSortOrder('asc');
                    }
                  }
                }}
              >
                <div className="flex items-center">
                  {field.label}
                  {/* Sort direction indicator */}
                  {sortBy === field.name && (
                    <span className="ml-1">
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </div>

                {filterEnabled && (
                  <button
                    className="ml-2 text-gray-500 text-sm focus:outline-none"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleColumnVisibility(field.name);
                    }}
                  >
                    {visibleColumns[field.name] ? <FaEye /> : <FaEyeSlash />}
                  </button>
                )}

                {filterEnabled && visibleColumns[field.name] &&(
                  <div className="inline-block">
                    <button
                      className="ml-2 text-gray-500 text-sm focus:outline-none"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(field.name)
                      }}
                    >
                      ▼
                    </button>
                    {/* {filterEnabled && columnDropdowns[field.name] && columnData[field.name] && (
                      <div
                        className="absolute left-0 bg-white border mt-2 rounded shadow-lg z-20 p-2 max-h-60 overflow-y-auto"
                        style={{ top: '100%', zIndex: 1000 }}
                      >
                        {columnData[field.name].map((value) => (
                          <label key={value} className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              className="form-checkbox"
                              checked={filterSelection[field.name]?.includes(value)}
                              onChange={(e) =>
                                handleCheckboxChange(field.name, value, e.target.checked)
                              }
                            />
                            <span className="text-sm text-gray-600">{value}</span>
                          </label>
                        ))}                         */}
                    {/* </div>
                    )} */}
                    {columnDropdowns[field.name] && (
                      <div
                        className="absolute left-0 bg-white border mt-2 rounded shadow-lg z-20 p-2"
                        style={{ top: "100%", zIndex: 1000 }}
                      >
                        {field.name === "coverageStartDate" || field.name === "increaseDate" ? (
                          <div className="flex flex-col gap-2">
                            <label className="text-sm font-semibold">Start Date</label>
                            <DatePicker
                              selected={dateFilterSelection[field.name]?.start}
                              onChange={(date) => handleDateChange(field.name, "start", date)}
                              selectsStart
                              startDate={dateFilterSelection[field.name]?.start}
                              endDate={dateFilterSelection[field.name]?.end}
                              className="border p-1 rounded"
                            />

                            <label className="text-sm font-semibold">End Date</label>
                            <DatePicker
                              selected={dateFilterSelection[field.name]?.end}
                              onChange={(date) => handleDateChange(field.name, "end", date)}
                              selectsEnd
                              startDate={dateFilterSelection[field.name]?.start}
                              endDate={dateFilterSelection[field.name]?.end}
                              minDate={dateFilterSelection[field.name]?.start}
                              className="border p-1 rounded"
                            />

                            <button
                              className="mt-2 bg-blue-500 text-white p-1 rounded"
                              onClick={() => {
                                applyDateFilter(field.name);
                                toggleDropdown(field.name);
                              }}
                            >
                              Apply
                            </button>

                            <button
                              className="mt-2 bg-red-500 text-white p-1 rounded"
                              onClick={() => clearDateFilter(field.name)}
                            >
                              Clear
                            </button>
                          </div>
                        ) : (
                          columnData[field.name]?.map((value) => (
                            <label key={value} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                className="form-checkbox"
                                checked={filterSelection[field.name]?.includes(value)}
                                onChange={(e) =>
                                  handleCheckboxChange(field.name, value, e.target.checked)
                                }
                              />
                              <span className="text-sm text-gray-600">{value}</span>
                            </label>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="text-gray-700">
          {filteredContracts.map((contract, index) => (
            <tr
              key={contract.contractId || index}
              className={`border-t ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-yellow-300`}
            >
              {/* Render specific fields */}
              {/* <td className="px-4 py-2">
                <button
                  className="text-sss-info underline"
                  onClick={() => handleOpenViewModal(contract)}
                >
                  {contract.contractNumber || 'N/A'}
                </button>
              </td>
              <td className="px-4 py-2">{contract.contractClass || 'N/A'}</td>
              <td className="px-4 py-2">{contract.coverageStartDate || 'N/A'}</td>
              <td className="px-4 py-2">{contract.coverageType || 'N/A'}</td>
              <td className="px-4 py-2">{contract.coverage || 'N/A'}</td>
              <td className="px-4 py-2">{contract.visitFrequency || 'N/A'}</td>
              <td className="px-4 py-2">{contract.billingLevel || 'N/A'}</td>
              <td className="px-4 py-2">{contract.billingFrequency || 'N/A'}</td>
              <td className="px-4 py-2">{contract.invoiceAmount || 'N/A'}</td>
              <td className="px-4 py-2">{contract.increaseDate || 'N/A'}</td>
              <td className="px-4 py-2">{contract.increasePercent || 'N/A'}</td>
              <td className="px-4 py-2">{contract.increaseFrequency || 'N/A'}</td>
              <td className="px-4 py-2">{contract.holdPeriod || 'N/A'}</td> */}
              
              {maintenanceContractFields.map((field) => (
                <td 
                  key={field.name} 
                  style={{ 
                    display: filterEnabled && !visibleColumns[field.name] ? 'none' : 'table-cell' 
                  }}
                  className="px-4 py-2"
                >
                  {field.name === 'contractNumber' ? (
                    <button
                      className="text-sss-info underline"
                      onClick={() => handleOpenViewModal(contract)}
                    >
                      {contract[field.name] || 'N/A'}
                    </button>
                  ) : (
                    contract[field.name] || 'N/A'
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>

      </table>






      {/* Pagination Controls */}
      <PaginationControls
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />


      <AddContractModal
        open={isAddOpen}
        handleClose={handleCloseAddModal}
        updateList={setContracts}
        allOptions={options}
      />


      <ViewContractModal
        open={isViewOpen}
        handleClose={handleCloseViewModal}
        contract={selectedContract}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        allContracts={contracts}
        allOptions={options}
        updateAll={setContracts}

      />


    </div >
  );

};

export default Maintenancecontractlist;